import PropTypes from "prop-types"
import { PERIOD, CONTENT_SET, SEARCHABLE_MENU_ITEM } from "helpers/shapes"
import { Card } from "@mui/material"
import classNames from "classnames"
import { isEmpty } from "lodash"
import ComparisonItem from "./components/comparison-item"
import SelectedDate from "components/selected-date"
import PeriodSelector from "components/period-selector"
import DateSelector from "components/date-picker"
import SearchableMenu from "components/searchable-menu"

import "./style.scss"

export default function ComparisonSettings({
  addOptions,
  comparisonItems,
  datesAdjusted,
  dispatch,
  earliestDate,
  endDate,
  fixedItemNumber,
  headline,
  latestDate,
  menuItems,
  openDialog,
  period,
  resetDate,
  selectedComparisonType,
  selectedDate,
  setPeriod,
  setSelectedComparisonType,
  setSelectedDate,
  singleDateSelector,
  startDate,
  trackSetPeriod,
  unmodeledDates,
}) {
  function handleSetPeriod(change) {
    let period = change
    if (change.startDate) {
      period = {
        startDate: change.adjusted.startDate || change.startDate,
        endDate: change.adjusted.endDate || change.endDate,
      }
    }

    trackSetPeriod && trackSetPeriod(period)
    setPeriod(period)
  }

  const hasHeadline = !isEmpty(headline)
  return <Card square elevation={1} className={classNames("modules_comparison-settings", { "has-headline": hasHeadline })}>
    <div className={classNames("comparison-top-row", { "fixed-item-number": fixedItemNumber })}>
      <div className="comparison-type-select-menu">
        <SearchableMenu items={menuItems} current={selectedComparisonType.id} onSelect={(item) => setSelectedComparisonType(item)} />
      </div>
      {comparisonItems.map((item, i) =>
        <ComparisonItem
          key={item.id}
          dispatch={dispatch}
          className={classNames({ "initial-item": i === 0 })}
          item={item}
          removeEnabled={i > 0}
          openDialog={openDialog}
        />,
      )}
      {comparisonItems.length < 5 && addOptions && <div data-test-class="comparison-add-button" className="comparison-add-wrapper">{addOptions}</div>}
    </div>
    <hr />
    <div className="comparison-bottom-row">
      {singleDateSelector
        ? <DateSelector {...{ earliestDate, latestDate, selectedDate, exclusionMap: unmodeledDates, onChange: setSelectedDate, adjusted: datesAdjusted }} />
        : <>
          <PeriodSelector {...{
              earliestDate,
              latestDate,
              endDate,
              startDate,
              period,
              onChange: handleSetPeriod,
              periodAdjusted: datesAdjusted,
            }}
          />
          {selectedDate < endDate && <SelectedDate date={selectedDate} resetHandler={resetDate} performance={selectedComparisonType.id === "performance"} />}
        </>}
      {headline && <div className="comparison-headline">{headline}</div>}
    </div>
  </Card>
}

ComparisonSettings.propTypes = {
  account: PropTypes.string.isRequired,
  addOptions: PropTypes.node,
  baseUrl: PropTypes.string.isRequired,
  comparisonItems: PropTypes.array.isRequired,
  contentSets: PropTypes.arrayOf(CONTENT_SET).isRequired,
  datesAdjusted: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
  earliestDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  fixedItemNumber: PropTypes.bool,
  headline: PropTypes.node,
  latestDate: PropTypes.string.isRequired,
  menuItems: PropTypes.arrayOf(SEARCHABLE_MENU_ITEM),
  modelId: PropTypes.string.isRequired,
  openDialog: PropTypes.func.isRequired,
  period: PERIOD.isRequired,
  resetDate: PropTypes.func.isRequired,
  selectedComparisonType: PropTypes.object.isRequired,
  selectedDate: PropTypes.string,
  setPeriod: PropTypes.func.isRequired,
  setSelectedComparisonType: PropTypes.func,
  setSelectedDate: PropTypes.func,
  singleDateSelector: PropTypes.bool,
  startDate: PropTypes.string.isRequired,
  trackSetPeriod: PropTypes.func,
  unmodeledDates: PropTypes.object,
}
